import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BookingState } from '@modules/booking/store';
import { SlotsHttpParams } from '@paymash/local-sdk/interfaces';
import { selectStoreUuid } from '@modules/company-page/store/company-stores';
import { reformatDateWithTimeUtils } from '@modules/core/utils/common';

const selectBookingState = createFeatureSelector<BookingState>('booking');

const selectAppointment = createSelector(selectBookingState, (s) => s.appointment);

export const selectAppointmentSlots = createSelector(selectAppointment, (s) => s.slots);

export const selectAvailableSlots = createSelector(selectAppointmentSlots, (slots) => {
  return slots.map((slot) => {
    const slotCopy = Object.assign({}, slot);
    slotCopy.slots = slotCopy.slots.filter(
      (slot, index, self) => self.findIndex((item) => slot.time === item.time) === index
    );
    return slotCopy;
  });
});

export const selectAppointmentService = createSelector(selectAppointment, (s) => s.services);

export const selectHideEmployeesSection = createSelector(selectAppointmentService, (services) => {
  return services.some((service) => service?.employees?.length !== 0);
});

export const selectParamsValue = createSelector(selectAppointment, (appointment) => {
  const params: SlotsHttpParams = {
    startDate: appointment.startDate,
    endDate: appointment.endDate,
    services: appointment.selectedEmployees, // []
  };

  return params;
});

export const selectAppointmentUuid = createSelector(selectAppointment, (s) => s.entity?.uuid as string);

export const selectAppointmentEntity = createSelector(selectAppointment, (s) => s.entity);

export const selectAppointmentServices = createSelector(selectAppointment, (s) => s.entity?.services);

export const selectAppointmentServicesSum = createSelector(selectAppointmentServices, (services) => {
  return services?.reduce((acc, s) => acc + Number(s.price), 0) || 0;
});

export const selectDraftAppointmentPayload = createSelector(
  selectAppointment,
  selectStoreUuid,
  (appointment, storeUuid) => {
    return {
      storeUuid: storeUuid,
      startedAt: appointment.startedAt,
      localCreationDate: reformatDateWithTimeUtils(new Date()),
      services: appointment.selectedEmployees,
    };
  }
);

export const selectStartedAt = createSelector(selectAppointment, (appointment) => appointment.startedAt);

export const selectStartDate = createSelector(selectAppointment, (appointment) => appointment.startDate);

export const selectStartedAtConfirm = createSelector(selectAppointmentEntity, (entity) => entity?.startedAt);

export const selectCustomer = createSelector(selectAppointmentEntity, (entity) => entity?.customer);

export const selectExternalNote = createSelector(selectAppointmentEntity, (entity) => entity?.externalNote);

export const selectPaymentMethod = createSelector(selectAppointment, (appointment) => appointment?.paymentMethod);
